import React from 'react'
import { observer } from 'mobx-react-lite'

import { CurrencyInput, ListItemAction, useGlobalCopyStore, useGoalStore } from '../../../common'
import { Goal } from '../../../core'
import { formatCurrency } from '../../../core/utils/NumberFormatting'

interface MonthlyPaymentActionProps {
  goal: Goal
}

export const MonthlyPaymentAction = observer(({ goal }: MonthlyPaymentActionProps) => {
  const { goals: copy } = useGlobalCopyStore()
  const { setAlert, setSelectedGoal, updateGoal } = useGoalStore()

  const [payment, setPayment] = React.useState<number>(goal.monthly_payment ?? 0)

  const isNew = !goal.guid
  const isInvalid = payment < 0 || payment > 99999999.99

  const handleSave = async () => {
    const updatedGoal = { ...goal, monthly_payment: payment }
    goal.monthly_payment = payment
    if (isNew) {
      setSelectedGoal(updatedGoal)
    } else {
      await updateGoal({ ...goal, monthly_payment: payment })
      setAlert(copy.alert_goal_updated_payment)
    }
  }

  const handleCancel = () => {
    setTimeout(() => {
      setPayment(goal.monthly_payment || 0)
    }, 250)
  }

  return (
    <ListItemAction
      isDisabled={goal.is_complete}
      isSaveDisabled={isInvalid}
      label={copy.details_monthly_payment}
      onCancel={handleCancel}
      onSave={handleSave}
      primaryText={copy.details_monthly_payment}
      secondaryText={formatCurrency(goal.monthly_payment, '0,0')}
      zeroStateText={!goal.monthly_payment ? copy.add_monthly_payment : undefined}
    >
      <CurrencyInput
        amount={payment}
        autoFocus={true}
        error={isInvalid}
        fullWidth={true}
        minAmount={0}
        setAmount={(v) => setPayment(!isNaN(Number(v)) ? Number(v) : payment)}
        sx={{ '.MuiTypography-body1': { p: 0 } }}
      />
    </ListItemAction>
  )
})
